import React from 'react';
import { BounceLoader } from 'react-spinners';

const MiniLoader = (props) => {


  return (
    <>
      <BounceLoader
        loading={props.load}
        size={props.size || '20'}
        color={'var(--pry-bold-color)'}
        className={`ms-3 ${ props.class } `}
      />

    </>
  );
};

export default MiniLoader;

